import { ILinkedServiceTypeMetadata } from 'app/extensibility/metadatas/resource-type/linked-service-type-metadata';

import { CouchbaseLinkedService, couchbaseAuthTypes } from 'app/model/linkedservice/couchbase.linkedservice';
import { Metamodel } from 'app/model/base/model';
import { CouchbaseCopySource } from 'app/model/pipeline/copysource/couchbase.copysource';
import { format } from 'app/shared/utils/string.util';
import { deprecatedConnectorDocLink } from 'app/shared/constants/links.const';

export const couchbaseMetadata: ILinkedServiceTypeMetadata = {
    type: Metamodel.modelFor(CouchbaseLinkedService).name,
    displayName: format(stringResources.ModelName_DisplayTextLegacyTemplate, stringResources.Couchbase_DisplayText),
    linkedServiceKind: 'table',
    icon: {
        className: 'svg-i-100x100-couchbase'
    },
    warningMessage: stringResources.Connector_Legacy_IsDeprecatedWarning,
    warningMessageHyperlink: deprecatedConnectorDocLink,
    warningTooltip: stringResources.Connector_Legacy_IsDeprecatedHint,
    notShowInTypeSelection: true,
    isFirstClass: true,
    supportDatasetV2: true,
    category: ['NoSQL'],
    copySinkTypes: [],
    copySourceTypes: [Metamodel.modelFor(CouchbaseCopySource).name],
    controls: [
        {
            type: 'select-button-switch',
            required: true,
            isLabelVertical: true,
            options: [
                {
                    label: stringResources.ModelName_ConnectionString,
                    value: false
                },
                {
                    label: stringResources.AzureKeyVault_DisplayText,
                    value: true,
                    hideAKVOptionIfNotChosen: false
                }
            ],
            bind: 'enableAKV',
            isNotRelatedToCredential: true,
            defaultValue: false,
            cases: [
                {
                    caseValue: true,
                    children: [
                        {
                            type: 'azure-key-vault',
                            bind: 'referedAKV',
                            isLabelVertical: true
                        }
                    ]
                },
                {
                    caseValue: false,
                    children: [
                        {
                            type: 'textbox',
                            bind: 'server',
                            label: stringResources.ModelName_ServerName,
                            required: true,
                            validators: [
                                { type: 'required', errorMessage: '' }
                            ],
                            isLabelVertical: true
                        },
                        {
                            type: 'textbox',
                            bind: 'port',
                            label: stringResources.ModelName_Port,
                            isLabelVertical: true,
                            inputType: 'number',
                            min: 0
                        },
                        {
                            type: 'select-switch',
                            bind: 'authMech',
                            label: stringResources.ModelName_AuthMech,
                            required: true,
                            validators: [
                                { type: 'required', errorMessage: '' }
                            ],
                            isLabelVertical: true,
                            options: [
                                {
                                    label: stringResources.AuthenticationType_NoAuthentication,
                                    value: couchbaseAuthTypes.NoAuthentication
                                },
                                {
                                    label: stringResources.AuthenticationType_UseCredentials,
                                    value: couchbaseAuthTypes.UseCredentials
                                }
                            ],
                            defaultValue: couchbaseAuthTypes.NoAuthentication,
                            cases: [
                                {
                                    caseValue: couchbaseAuthTypes.UseCredentials,
                                    children: [
                                        {

                                            type: 'dynamic-akv-switcher',
                                            hideAKVSwitcherInConnStrProps: true,
                                            bind: 'credString',
                                            label: stringResources.ModelName_CredString,
                                            child: {
                                                type: 'password',
                                                label: stringResources.ModelName_CredString,
                                                required: true,
                                                validators: [
                                                    { type: 'required', errorMessage: '' }
                                                ],
                                                isLabelVertical: true
                                            },
                                            description: format(stringResources.AzureKeyVaultSecretName_Tooltip_Template,
                                                format(stringResources.ModelName_LinkedServiceTemplate, stringResources.Couchbase_DisplayText),
                                                stringResources.ModelName_CredString)
                                        }
                                    ]
                                }
                            ]
                        },
                        {
                            type: 'key-val-list',
                            bind: 'additionalFields',
                            label: stringResources.AdditionalConnectionStringFields
                        }
                    ]
                }
            ]
        }
    ]
};
